<section class="bg-primary-500 px-6 py-20 md:px-12 lg:px-20 dark:bg-surface-950 overflow-hidden">
	<app-headline-large
		[title]="content.title"
		class="text-center! text-white!"></app-headline-large>
	<app-body-large
		[description]="content.description"
		class="text-center! text-white! mt-4"></app-body-large>

	@if (content.copy.length > 0){
	<div class="grid grid-cols-1 lg:grid-cols-2 gap-6 pt-8">
		@for (item of content.copy; track item.title) {
		<div
			class="group p-6 pr-8 bg-surface-50 dark:bg-surface-800 border border-surface-100 dark:border-surface-700 flex items-center gap-2 md:gap-6">
			<span class="w-12 h-12 bg-primary-50 dark:bg-surface-0 flex items-center justify-center">
				<i class="pi pi-check leading-normal! text-primary-500 dark:text-surface-0 p-2"></i>
			</span>
			<div class="flex flex-col">
				<h3
					class="text-surface-900 dark:text-surface-0 text-base lg:text-lg font-semibold flex-1 leading-tight"
					[innerHTML]="item.title"></h3>
				<app-body-large [description]="item.description"></app-body-large>
			</div>
		</div>
		}
	</div>
	}
</section>
